import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { animated, useSpring, type SpringValues } from '@react-spring/web';

interface ScoreProps {
  scoreDisplayText: string;
  color: string;
  disableAnimations: boolean;
  shouldHideScore: boolean;
}

export const Score = ({
  scoreDisplayText,
  color,
  disableAnimations,
  shouldHideScore,
}: ScoreProps) => {
  const { scoreTransform, circleTransform, scoreOpacity, circleOpacity } =
    useSpring({
      scoreTransform: shouldHideScore ? 'translateY(100%)' : 'translateY(0%)',
      circleTransform: shouldHideScore ? 'translateY(0%)' : 'translateY(-100%)',
      scoreOpacity: shouldHideScore ? 0 : 1,
      circleOpacity: shouldHideScore ? 1 : 0,
      immediate: disableAnimations,
    });

  const containsPercentage = scoreDisplayText.includes('%');
  return (
    <Box
      width={containsPercentage ? '5ch' : '4ch'}
      height="2ch"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      <Box
        as={animated.div}
        position="absolute"
        width="2ch"
        height="2ch"
        borderRadius="full"
        bg={color}
        style={
          {
            transform: circleTransform,
            opacity: circleOpacity,
          } as SpringValues
        }
      />
      <Text
        as={animated.span}
        textAlign="center"
        fontWeight="bold"
        fontSize="inherit"
        style={
          {
            transform: scoreTransform,
            opacity: scoreOpacity,
          } as SpringValues
        }
      >
        {scoreDisplayText}
      </Text>
    </Box>
  );
};
